import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'
import { measurements } from '@mobi/component-library/Foundations'
import { AppHeaderButtonStyled } from '../AppHeader/Components/Buttons/Buttons.styles'

export const SearchOverlayStyled = styled.div({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1,
  background: hexColors.white,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'scroll',
})

export const SearchOverlayHeaderStyled = styled.div({
  width: '100%',
  zIndex: 2,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  height: measurements.mobi.headerHeight,
  minHeight: measurements.mobi.headerHeight,
  background: hexColors.blueDiamond,
})

export const CloseButtonStyled = styled(AppHeaderButtonStyled)({
  marginLeft: 'auto',
})

export const SearchResultsContainerStyled = styled.div({
  boxSizing: 'border-box',
  margin: '0 auto',
  width: '100%',
  minWidth: measurements.mobi.minWidth,
  maxWidth: measurements.mobi.maxWidth,

  '@supports (min-height: 100dvh)': { minHeight: '100dvh' },

  overflowY: 'scroll', // scroll, not auto for momentum scroll to work
  WebkitOverflowScrolling: 'touch', // enables momentum scroll < IOS11
  minHeight: 0,
  flex: 1,
  background: hexColors.gainsboro,

  '&::after': {
    content: '""',
    display: 'block',
    paddingBottom: '22rem', // Height of footer and notification(s)
  },
})
